import React from 'react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import { BodyText, Link, Alert } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'

function LiveNotAllowed() {
  const { stepUpNeeded, authflowUrl } = useApplicationContext()

  if (stepUpNeeded === true) {
    return (
      <div>
        <BodyText size="sm">
          <Alert type="info">
            <Message
              id="full-auth-needed.stepUpNeeded.message"
              link={(label) => (
                <Link
                  href={authflowUrl}
                  data-dxa="step-up-needed,click,additional-auth-needed"
                >
                  {label}
                </Link>
              )}
            />
          </Alert>
        </BodyText>
      </div>
    )
  }

  return (
    <div>
      <BodyText size="sm">
        <Alert type="info">
          <Message
            id="full-auth-needed.liveNotAllowed.message"
            link={(label) => (
              <Link
                href="https://developer.paypal.com/support/"
                target="_blank"
                rel="noopener noreferrer"
                data-dxa="live-not-allowed,click,contact-developer-support"
              >
                {label}
              </Link>
            )}
          />
        </Alert>
      </BodyText>
    </div>
  )
}

export default injectWorldReady(LiveNotAllowed)
